<template>
  <div class="blocks-right">
    <div class="title-wrapper">
      <div class="title">
        <span
          v-if="team.name"
          class="ma-0"
        >
          {{ team.name }}
        </span>
        <span
          v-else
          class="ma-0"
        >
          {{ $t('teams.teams_fields.default_team') }}
        </span>
        <span
          v-if="team.name"
          class="action"
          @click="editTeamHandler"
        >
          <UiIcon
            name="pen"
            color="#20815e"
          />
        </span>
        <span
          v-if="team.name && team.type !== 'owners'"
          class="action"
          @click="deleteTeamHandler"
        >
          <UiIcon
            name="trash-alt"
            color="var(--text-negative)"
          />
        </span>
      </div>
      <div
        v-if="$route.matched[3].meta.view === 'permissions' && !notEdit"
        class="buttons"
      >
        <div class="buttons-wrapper">
          <div class="text">
            {{ $t('permissions.save_changes', {teamName: team.name }) }}
          </div>
          <UiButton
            type="negative"
            class="btn-red"
            icon="times"
            @click="cancelChanges"
          >
            {{ $t(`team_popup.cancel_button`) }}
          </UiButton>
          <UiButton
            class="action-btn"
            filled
            icon="check"
            @click="saveChanges"
          >
            {{ $t(`team_popup.save_button`) }}
          </UiButton>
        </div>
      </div>
    </div>
    <div class="sub-nav">
      <nav class="menu">
        <RouterLink
          v-for="item in $_.filter(nav, e => team.name && team.type !== 'owners' || e.name !== 'permissions')"
          :key="item.name"
          :class="{active : isLinkActive(item.name)}"
          :to="item.link"
          class="item"
        >
          <span
            :title="$t(`teams.sub_nav.${item.name}`)"
            class="link-title"
          >
            {{ $t(`teams.sub_nav.${item.name}`) }}
          </span>
        </RouterLink>
      </nav>
    </div>
    <RouterView
      v-model:edit="notEdit"
      :team-info="team"
      :permissions="permissions"
      class="view"
      @refresh="refresh()"
      @refresh-users-list="refreshList()"
    />
  </div>
</template>

<script>
export default {

  props: {
    permissions: {
      type: Object,
      default() {
        return {
          affiliates_types_edit: [],
          affiliates_types_view: [],
          players_available_properties: [],
          reports_affiliates_types: [],
        };
      },
    },
    team: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ['open-delete', 'open-edit', 'refresh', 'refresh-users-list'],

  data() {
    return {
      isDataLoading: false,
      isPopupOpen: false,
      isActiveTeam: 0,
      // isConfirmOpen: false,

      notEdit: true,

      dataTeam: {},

      confirmMsg: '',
      confirmAction: '',
      confirmTitle: '',
      confirmType: '',
      actionName: '',
      actionFaIcon: '',
      actionIcon: '',
      currentTab: '',
      nav: [
        {
          name: 'users',
          link: 'users',
        },
        {
          name: 'permissions',
          link: 'permissions',
        },
      ],
      id: '',
    };
  },

  watch: {
    $route() {
      this.currentTab = this.$route.matched[3].meta.view;
    },
  },
  mounted() {
    this.currentTab = this.$route.matched[3].meta.view;
  },

  methods: {

    isLinkActive(name) {
      return this.currentTab === name;
    },

    saveChanges() {
      this.$eventBus.$emit('save-changes');
    },
    cancelChanges() {
      this.$eventBus.$emit('cancel-changes');
    },

    refreshList() {
      this.$emit('refresh-users-list');
    },
    refresh() {
      this.$emit('refresh');
    },

    editTeamHandler() {
      this.$emit('open-edit');
    },

    deleteTeamHandler() {
      this.$emit('open-delete');
    },
  },
};
</script>

<style lang="scss" scoped>
  .teams-list {
    .wrapper {
      width: 90%;
      min-width: 1140px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
  }
</style>
